var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightTakeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0562 13.8992C30.5762 12.6786 29.4333 11.7598 27.8379 11.3118C26.4116 10.9141 24.8208 10.9689 23.5728 11.4535L19.1247 13.1952L10.8413 7.94264C10.7453 7.87864 10.6265 7.85579 10.5168 7.87864L8.34533 8.26265C8.18989 8.29008 8.05733 8.39979 7.9979 8.54608C7.94305 8.69694 7.9659 8.86151 8.06191 8.98949L13.0585 15.5678L5.94991 18.3472L3.43105 15.8146C3.34419 15.7278 3.21618 15.6729 3.10189 15.6775L1.36475 15.7003C1.21389 15.7003 1.07675 15.7735 0.994469 15.9015C0.907611 16.0249 0.889335 16.1804 0.94419 16.3221L3.38532 22.5666C3.76475 23.5358 4.69731 24.1301 5.68018 24.1301C5.97734 24.1301 6.27904 24.0752 6.57619 23.9609L30.7956 14.4935C31.0288 14.3975 31.1476 14.1323 31.0562 13.8992Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightTakeOff);
export default __webpack_public_path__ + "static/media/FlightTakeOff.6a4c767d339a9467cb7a973db29eb5a5.svg";
export { ForwardRef as ReactComponent };